export const linkRegExp = /(https?:\/\/[^\s]+)/g;
export const onlyLatinLettersSymbolsNumbers = /^[A-Za-z0-9!@#$%^&*()_+\-=[\]{}|;:'",.<>?/~ \n]*$/;
